module.exports = __webpack_public_path__ + "media/images/home/card_funding-5a6bd5a6f877bc365f9f518f4d182622.jpg";